import { EApplications, EChannels } from 'core/model/enums';
import { TMaintenanceApplicationKey } from 'core/model/interfaces/maintenance';
import { CHANNEL_NAME_BY_CHANNEL_ID } from './general.constants';

export const MAINTENANCE_APPLICATIONS: Record<TMaintenanceApplicationKey, string> = {
  [`${EApplications.APP}-${EChannels.DIA_DIA}`]: `App ${CHANNEL_NAME_BY_CHANNEL_ID[EChannels.DIA_DIA]}`,
  [`${EApplications.WEB}-${EChannels.DIA_DIA}`]: `Web ${CHANNEL_NAME_BY_CHANNEL_ID[EChannels.DIA_DIA]}`,
  [`${EApplications.APP}-${EChannels.INSUMA}`]: `App ${CHANNEL_NAME_BY_CHANNEL_ID[EChannels.INSUMA]}`,
  [`${EApplications.WEB}-${EChannels.INSUMA}`]: `Web ${CHANNEL_NAME_BY_CHANNEL_ID[EChannels.INSUMA]}`,
} as const;

export const DEFAULT_MAINTENANCE_LIMIT = 500 as const;

/**
 * As business requirement, we need to set a default limit when fetching maintenance records.
 */
export const DEFAULT_MAINTENANCE_PARAMS = {
  limit: DEFAULT_MAINTENANCE_LIMIT,
};
